import { FC, SVGProps } from 'react';

const WalletIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M12.7855 10.0018H12.7842"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.0432 12.0039V12.685C16.0432 14.843 14.2883 16.5977 12.1232 16.5977H6.41917C4.25402 16.5977 2.5 14.843 2.5 12.685V7.32489C2.5 5.15973 4.25402 3.40491 6.41917 3.40491H12.1232C14.2883 3.40491 16.0432 5.15973 16.0432 7.32489V7.98822"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9496 12.0105H12.4797C11.6234 12.0105 10.9292 11.3163 10.9292 10.46V9.54521C10.9292 8.68888 11.6234 7.99475 12.4797 7.99475H15.9496C16.8059 7.99475 17.5001 8.68888 17.5001 9.54521V10.46C17.5001 11.3163 16.8059 12.0105 15.9496 12.0105Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default WalletIcon;
